import React from 'react';
import { type BrandRibbonCategoryProps } from './BrandRibbonCategory.types';
import { Wrapper, logoHoverColor } from './BrandRibbonCategory.styles';
import { Heading } from '../../atoms/Heading';
import { Text } from '../../atoms/Text';
import { MLogoContainer } from '@marriott/mi-web-ui-kit';
import { Types, useCheckBreakpoint } from '@marriott/mi-ui-library';

const COMPONENT_NAME = 'm-ui-library-BrandRibbonCategory';
const TEST_ID = 'ui-library-BrandRibbonCategory';

function BrandRibbonCategory({
  categorylabel = '',
  description = '',
  linklists = [],
  trackingProperties,
  ...rest
}: BrandRibbonCategoryProps) {
  const isDesktopAndAbove = useCheckBreakpoint('viewportL');
  const getTrackingDescription = (itemLabel?: string) =>
    trackingProperties?.trackingDescription && itemLabel
      ? `${trackingProperties.trackingDescription} - ${itemLabel}`
      : itemLabel || trackingProperties?.trackingDescription;

  return (
    <Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} {...rest}>
      <div>
        <Heading
          titleText={categorylabel}
          element={Types.tags.h3}
          variation={Types.headingType.subtitle}
          fontSize={Types.size.large}
          customClass="brand-ribbon-category-label"
        />
        <Text
          dangerouslySetInnerHTML={{ __html: description }}
          fontSize={Types.size.extraSmall}
          element={Types.tags.paragraph}
          customClass="brand-ribbon-category-description"
        />
      </div>
      <div>
        <ul className="p-0 brand-ribbon-category-list">
          {linklists.map(
            ({
              linkurl = '',
              id,
              brandtag = '',
              linkText = '',
              openinanewtab = false,
              clickTrackValue,
              custom_click_track_value,
            }) => (
              <li key={id} className="brand-ribbon-category-list-item">
                <MLogoContainer
                  brand={brandtag}
                  color="alternate-logo"
                  hoverColor={logoHoverColor}
                  aspectRatio="3:2"
                  width={isDesktopAndAbove ? 48 : 80}
                  height={isDesktopAndAbove ? 32 : 53.33}
                  alignment="Centered"
                  isLink={true}
                  linkUrl={linkurl}
                  brandFullName={linkText}
                  target={openinanewtab ? '_blank' : '_self'}
                  className={trackingProperties?.clickTrack ? 'custom_click_track' : ''}
                  data-custom_click_track_value={
                    custom_click_track_value ||
                    clickTrackValue ||
                    (trackingProperties?.location && getTrackingDescription(linkText)
                      ? `${trackingProperties.location}|${getTrackingDescription(linkText)}|${
                          openinanewtab ? 'external' : 'internal'
                        }`
                      : undefined)
                  }
                />
              </li>
            )
          )}
        </ul>
      </div>
    </Wrapper>
  );
}

export { BrandRibbonCategory, TEST_ID as M_BRANDRIBBONCATEGORY_TEST_ID };
